
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  on: {
    pageInit(e, page) {
      const app = this.$app;
      const $$ = this.$;
      $$('.sl-btn-renew').on('click', function (e) {
        e.preventDefault();
        var btn = $$(this);
        var packageId = btn.data('package-id');
        var previousPatientsStr = btn.attr('data-previous-patients');
        var previousPatients = [];
        try {
          previousPatients = JSON.parse(previousPatientsStr);
        } catch (ex) {
          previousPatients = [];
        }
        if (!previousPatients.length) {
          app.dialog.alert('No previous patient data found. Redirecting to subscribe.', 'mDOC', function () {
            app.views.main.router.navigate('/subscription-booking/' + packageId + '/');
          });
          return;
        }
        app.dialog.confirm('Renew subscription with your previous patient details?', 'Renew Subscription', function () {
          var params = 'package_id=' + encodeURIComponent(packageId);
          previousPatients.forEach(function (id) {
            params += '&patient_ids[]=' + encodeURIComponent(id);
          });
          app.preloader.show();
          app.methods.authHeader();
          app.request({
            url: app.data.remoteUrl + 'subscription-purchase',
            method: 'POST',
            data: params,
            dataType: 'json',
            success: function (returnData) {
              app.preloader.hide();
              if (returnData['status']) {
                var resData = returnData['data'];
                if (resData['requires_payment']) {
                  initiatePayment(packageId);
                } else {
                  app.dialog.alert(returnData['msg'] || 'Subscription renewed successfully!', 'Success', function () {
                    app.views.main.router.navigate('/home/');
                    app.views.main.router.clearPreviousHistory();
                  });
                }
              } else {
                app.dialog.alert(returnData['msg'] || 'Failed to renew subscription');
              }
            },
            error: function (xhr) {
              app.preloader.hide();
              app.methods.requestError(xhr);
            }
          });
        });
      });
      function initiatePayment(pkgId) {
        app.methods.authHeader();
        app.preloader.show();
        app.request({
          url: app.data.remoteUrl + 'payments/initiate',
          method: 'POST',
          data: 'type=subscription&package_id=' + encodeURIComponent(pkgId),
          dataType: 'json',
          success: function (response) {
            app.preloader.hide();
            var paymentUrl = response.data && response.data.payment_url;
            if (response.status && paymentUrl) {
              if (app.device.cordova) {
                var ref = cordova.InAppBrowser.open(paymentUrl, '_blank', 'location=yes,hideurlbar=yes,hidenavigationbuttons=yes,toolbarcolor=#ffffff,hardwareback=no,closebuttoncolor=#e7364d');
                ref.addEventListener('loadstop', function (event) {
                  app.preloader.hide();
                  if (event.url && event.url.indexOf('verify-redirect') > -1) {
                    setTimeout(function () {
                      ref.close();
                    }, 2000);
                  }
                });
                ref.addEventListener('exit', function () {
                  app.views.main.router.navigate('/subscription/', { reloadCurrent: true });
                });
              } else {
                window.open(paymentUrl, '_blank');
              }
            } else {
              app.dialog.alert(response.msg || 'Payment gateway URL not available');
            }
          },
          error: function () {
            app.preloader.hide();
            app.dialog.alert('Failed to initiate payment');
          }
        });
      }
    }
  },
  id: '20d5792840',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page" data-name="subscription_list" id="subscriptionListPage" data-ignore-cache="false"\n        removeElements=\'true\' router.off=\'on\'>\n        <div class="navbar">\n            <div class="navbar-inner sliding">\n                <div class="left">\n                    <a href="#" class="link back">\n                        <i class="icon icon-back"></i>\n                    </a>\n                </div>\n                <div class="title">Subscription Plans</div>\n            </div>\n        </div>\n        <div class="page-content">\n\n            ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.data, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="card sl-card';
          r += Template7Helpers.js_if.call(ctx_2, '@index % 2 == 1', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += ' sl-card-alt';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '">\n                <!-- Card Header with gradient -->\n                <div class="sl-card-header">\n                    <div class="sl-plan-icon">\n                        <i class="material-icons">';
          r += Template7Helpers.js_if.call(ctx_2, 'this.type == 1', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += 'group';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += 'person';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</i>\n                    </div>\n                    <div class="sl-plan-info">\n                        <p class="sl-plan-name">';
          r += c(ctx_2.name, ctx_2);
          r += '</p>\n                        <p class="sl-plan-price">&#8377; ';
          r += c(ctx_2.amount, ctx_2);
          r += '</p>\n                    </div>\n                    ';
          r += Template7Helpers.js_if.call(ctx_2, 'this.is_active', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                    <div class="sl-status-badge sl-badge-active">Active</div>\n                    ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                    ';
          r += Template7Helpers.js_if.call(ctx_2, 'this.is_subcribed && !this.is_active', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                    <div class="sl-status-badge sl-badge-expired">Expired</div>\n                    ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                </div>\n\n                <!-- Features List -->\n                ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.package_item.length, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                <div class="sl-card-body">\n                    ';
              r += Template7Helpers.each.call(ctx_3, ctx_3.package_item, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                    <div class="sl-feature-item">\n                        <i class="material-icons">check_circle</i>\n                        <span>';
                  r += c(ctx_4, ctx_4);
                  r += '</span>\n                    </div>\n                    ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                </div>\n                ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n\n                <!-- Plan Details Chips -->\n                <div class="sl-chips-row">\n                    <div class="sl-chip">\n                        <i class="material-icons">event</i>\n                        <span>';
          r += c(ctx_2.validity, ctx_2);
          r += ' months</span>\n                    </div>\n                    <div class="sl-chip">\n                        <i class="material-icons">people_outline</i>\n                        <span>';
          r += c(ctx_2.number_of_patients, ctx_2);
          r += ' member';
          r += Template7Helpers.js_if.call(ctx_2, 'parseInt(this.number_of_patients) > 1', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += 's';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</span>\n                    </div>\n                    ';
          r += Template7Helpers.js_if.call(ctx_2, 'parseInt(this.appointment_total) > 0', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                    <div class="sl-chip">\n                        <i class="material-icons">local_hospital</i>\n                        <span>';
              r += c(ctx_3.appointment_total, ctx_3);
              r += ' OPD</span>\n                    </div>\n                    ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                </div>\n\n                <!-- Subscription Status & Actions -->\n                <div class="sl-card-footer">\n                    ';
          r += Template7Helpers.js_if.call(ctx_2, 'this.is_active', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                    <!-- Active subscription: show details only -->\n                    <div class="sl-validity-info">\n                        <i class="material-icons">verified</i>\n                        <span>Valid upto ';
              r += c(ctx_3.valid_upto, ctx_3);
              r += '</span>\n                    </div>\n                    <a href="/subscription-details/';
              r += c(ctx_3.id, ctx_3);
              r += '/" class="sl-action-btn sl-btn-details">\n                        <i class="material-icons">visibility</i>\n                        <span>View Details</span>\n                    </a>\n                    ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n\n                    ';
          r += Template7Helpers.js_if.call(ctx_2, 'this.is_subcribed && !this.is_active', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                    <!-- Expired subscription: show renew only -->\n                    <div class="sl-validity-info sl-expired-info">\n                        <i class="material-icons">schedule</i>\n                        <span>Expired on ';
              r += c(ctx_3.valid_upto, ctx_3);
              r += '</span>\n                    </div>\n                    <a href="#" class="sl-action-btn sl-btn-renew" data-package-id="';
              r += c(ctx_3.id, ctx_3);
              r += '" data-previous-patients="';
              r += '">\n                        <i class="material-icons">autorenew</i>\n                        <span>Renew Subscription</span>\n                    </a>\n                    ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n\n                    ';
          r += Template7Helpers.js_if.call(ctx_2, '!this.is_subcribed', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                    <!-- Not subscribed: show subscribe now -->\n                    <a href="/subscription-booking/';
              r += c(ctx_3.id, ctx_3);
              r += '/" class="sl-action-btn sl-btn-subscribe">\n                        <i class="material-icons">card_membership</i>\n                        <span>Subscribe Now</span>\n                    </a>\n                    ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                </div>\n            </div>\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n        </div>\n    </div>\n';
      return r;
    }(this);
  },
  style: `
[data-f7-20d5792840] .sl-card {
        border-radius: 16px;
        overflow: hidden;
        box-shadow: 0 2px 12px rgba(15, 31, 46, 0.06);
        margin: 12px 14px;
        padding: 0;
        border: 1px solid var(--mdoc-border);
        background: var(--mdoc-white);
    }
[data-f7-20d5792840] .sl-card-header {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 16px;
        background: linear-gradient(160deg, var(--mdoc-green-soft) 0%, var(--mdoc-blue-soft) 100%);
        color: var(--mdoc-ink);
        position: relative;
        overflow: hidden;
        border-bottom: 1px solid rgba(46, 182, 125, 0.18);
    }
[data-f7-20d5792840] .sl-card-header::after {
        content: "";
        position: absolute;
        top: -30px;
        right: -30px;
        width: 120px;
        height: 120px;
        background: radial-gradient(circle, rgba(255,255,255,0.55) 0%, rgba(255,255,255,0) 70%);
        border-radius: 50%;
        pointer-events: none;
    }
[data-f7-20d5792840] .sl-plan-icon {
        width: 44px;
        height: 44px;
        border-radius: 14px;
        background: var(--mdoc-white);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        position: relative;
        z-index: 1;
        box-shadow: 0 2px 8px rgba(15, 31, 46, 0.08);
    }
[data-f7-20d5792840] .sl-plan-icon i {
        font-size: 22px;
        color: var(--mdoc-green-dark);
    }
[data-f7-20d5792840] .sl-plan-info {
        flex: 1;
        min-width: 0;
        position: relative;
        z-index: 1;
    }
[data-f7-20d5792840] .sl-plan-name {
        font-size: 15px;
        font-weight: 700;
        margin: 0;
        color: var(--mdoc-ink);
        line-height: 1.2;
    }
[data-f7-20d5792840] .sl-plan-price {
        font-size: 20px;
        font-weight: 800;
        margin: 4px 0 0;
        letter-spacing: -0.3px;
        color: var(--mdoc-green-dark);
    }
[data-f7-20d5792840] .sl-status-badge {
        padding: 3px 10px;
        border-radius: 100px;
        font-size: 10px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.4px;
        flex-shrink: 0;
        position: relative;
        z-index: 1;
    }
[data-f7-20d5792840] .sl-badge-active {
        background: var(--mdoc-green);
        color: var(--mdoc-white);
    }
[data-f7-20d5792840] .sl-badge-expired {
        background: #FFF1E0;
        color: #C2570A;
    }

    /* Alternate (every other card): amber/peach pastel like home Family Plan */
[data-f7-20d5792840] .sl-card-alt .sl-card-header {
        background: linear-gradient(160deg, #FFF1E0 0%, #FFD9B3 100%);
        border-bottom-color: rgba(245, 179, 1, 0.30);
    }
[data-f7-20d5792840] .sl-card-alt .sl-plan-icon i { color: #C2570A; }
[data-f7-20d5792840] .sl-card-alt .sl-plan-price { color: #C2570A; }

[data-f7-20d5792840] .sl-card-body {
        padding: 14px 16px 4px;
    }
[data-f7-20d5792840] .sl-feature-item {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        padding: 5px 0;
    }
[data-f7-20d5792840] .sl-feature-item i {
        font-size: 16px;
        color: var(--mdoc-green);
        margin-top: 1px;
        flex-shrink: 0;
    }
[data-f7-20d5792840] .sl-feature-item span {
        font-size: 13px;
        color: var(--mdoc-ink);
        line-height: 1.4;
    }

[data-f7-20d5792840] .sl-chips-row {
        display: flex;
        flex-wrap: wrap;
        gap: 6px;
        padding: 10px 16px 14px;
    }
[data-f7-20d5792840] .sl-chip {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        background: var(--mdoc-green-soft);
        padding: 4px 10px;
        border-radius: 100px;
    }
[data-f7-20d5792840] .sl-chip i {
        font-size: 13px;
        color: var(--mdoc-green-dark);
    }
[data-f7-20d5792840] .sl-chip span {
        font-size: 11.5px;
        color: var(--mdoc-green-dark);
        font-weight: 700;
    }
[data-f7-20d5792840] .sl-chip:nth-child(2) { background: var(--mdoc-blue-soft); }
    .sl-chip:nth-child(2) i,
[data-f7-20d5792840] .sl-chip:nth-child(2) span { color: var(--mdoc-blue-dark); }
[data-f7-20d5792840] .sl-chip:nth-child(3) { background: #FFF1E0; }
    .sl-chip:nth-child(3) i,
[data-f7-20d5792840] .sl-chip:nth-child(3) span { color: #C2570A; }

[data-f7-20d5792840] .sl-card-footer {
        padding: 12px 16px 16px;
        border-top: 1px solid var(--mdoc-border);
        display: flex;
        flex-direction: column;
        gap: 10px;
    }
[data-f7-20d5792840] .sl-validity-info {
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 8px 12px;
        background: var(--mdoc-green-soft);
        border-radius: 10px;
    }
[data-f7-20d5792840] .sl-validity-info i {
        font-size: 17px;
        color: var(--mdoc-green-dark);
    }
[data-f7-20d5792840] .sl-validity-info span {
        font-size: 12.5px;
        color: var(--mdoc-green-dark);
        font-weight: 700;
    }
[data-f7-20d5792840] .sl-validity-info.sl-expired-info {
        background: #FFF1E0;
    }
    .sl-validity-info.sl-expired-info i,
[data-f7-20d5792840] .sl-validity-info.sl-expired-info span {
        color: #C2570A;
    }

[data-f7-20d5792840] .sl-action-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        padding: 12px;
        border-radius: 100px;
        font-size: 14px;
        font-weight: 700;
        text-decoration: none;
        text-align: center;
    }
[data-f7-20d5792840] .sl-action-btn i {
        font-size: 18px;
    }
[data-f7-20d5792840] .sl-btn-subscribe {
        background: var(--mdoc-green);
        color: var(--mdoc-white);
        box-shadow: 0 4px 12px rgba(46, 182, 125, 0.25);
    }
[data-f7-20d5792840] .sl-btn-subscribe:active { background: var(--mdoc-green-dark); }
[data-f7-20d5792840] .sl-btn-details {
        background: var(--mdoc-bg);
        color: var(--mdoc-ink);
        border: 1px solid var(--mdoc-border);
    }
[data-f7-20d5792840] .sl-btn-details i {
        color: var(--mdoc-green-dark);
    }
[data-f7-20d5792840] .sl-btn-renew {
        background: var(--mdoc-green);
        color: var(--mdoc-white);
        box-shadow: 0 4px 12px rgba(46, 182, 125, 0.25);
    }
[data-f7-20d5792840] .sl-btn-renew:active { background: var(--mdoc-green-dark); }
`,
  styleScoped: true
};
    